/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import SafeLink from "components/commons/SafeLink";
import BrokingFaqs from "./BrokingFaqs";
import {WealthyEnv} from "helpers";

const BrokingFaqsContainer = () => {
  const faqList = [
    {
      question: "What is a demat account and how does it work?",
      answer: "A demat account is like a digital vault for your financial securities. It holds stocks, bonds, and mutual funds in a dematerialised form. You can use Wealthy’s demat account to invest and trade in stocks, bonds and ETFs."
    },
    {
      question: "What types of securities can be held in a demat account?",
      answer: "There are a number of securities which you can hold in demat form in India such as equity shares of listed and unlisted companies, government bonds, corporate bonds, ETF units, and mutual fund units."
    },
    {
      question: "What are the charges for opening and maintaining a demat and trading account with Wealthy?",
      answer: `Wealthy demat account doesn’t have any account opening charges. Account maintenance charges are free for the first year.To check brokerage charges for Delivery, Intraday, Futures and Options trade, visit <SafeLink href='${WealthyEnv.URL}/pricing/' rel='noopener noreferrer' target='_blank'>${WealthyEnv.URL}/pricing/</SafeLink>`
    },
    {
      question: "What are the benefits of having a demat and trading account with Wealthy?",
      answer: "Wealthy has the minimal brokerage charges and does not impose any account maintenance fees on its users for the first year. With Wealthy Broking, you get exclusive access to curated stock baskets called Wealthy Ideas created by our team of experts. The research tools and in-depth insights will help your investment experience incredible with Wealthy."
    }
  ];
  return (
    <BrokingFaqs faqList={faqList} />
  );
};

export default BrokingFaqsContainer;
